import { useEffect } from 'react';
import confetti from 'canvas-confetti';

interface PremiumConfettiProps {
  trigger: boolean;
}

export function PremiumConfetti({ trigger }: PremiumConfettiProps) {
  useEffect(() => {
    if (!trigger) return;

    // Fire confetti from both sides
    const duration = 3000;
    const end = Date.now() + duration;

    const colors = ['#FFD700', '#FFA500', '#FF6347', '#9400D3', '#00CED1'];

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.7 },
        colors,
      });

      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.7 },
        colors,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    // Initial burst
    confetti({
      particleCount: 100,
      spread: 100,
      origin: { y: 0.6 },
      colors,
    });

    frame();
  }, [trigger]);

  return null;
}
